import React from 'react';

import styles from './styles.module.css';

import LogoPernambucoGovernment from '../../../assets/images/logos/logo_gov_origin_horizontal_white.png';

export interface FooterProps {
  internalLinks: {
    text: string;
    link: string;
    target?: string;
  }[];
  externalLinks: {
    text: string;
    link: string;
  }[];
  socialMediaLinks: {
    Icon: React.FC<React.SVGProps<SVGSVGElement>>;
    link: string;
  }[];
  contacts: {
    Icon: React.FC<React.SVGProps<SVGSVGElement>>;
    text: string;
    link: string;
    target?: string;
  }[];
}

export const Footer: React.FC<FooterProps> = ({
  internalLinks,
  externalLinks,
  socialMediaLinks,
  contacts,
}) => {
  return (
    <>
      <section className={styles.footerLinksContainerWrapper}>
        <section className={styles.footerLinksContainer}>
          <ul className={styles.footerLinks}>
            {internalLinks?.map(({ text, link, target }, index) => (
              <li className={styles.footerLinksItem} key={index}>
                <a href={link} target={target || ''} rel="noreferrer">
                  <hr />
                  <span>{text}</span>
                </a>
              </li>
            ))}
          </ul>

          <h2 className={styles.footerLinksTitle}>Links externos</h2>

          <ul className={styles.footerLinks}>
            {externalLinks?.map(({ text, link }, index) => (
              <li className={styles.footerLinksItem} key={index}>
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Link externo: ${text}`}
                >
                  <hr />
                  <span>{text}</span>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </section>

      <section className={styles.footerGovInfoContainer}>
        <section className={styles.footerGovInfoSocialMediaLinksContainer}>
          <img
            src={LogoPernambucoGovernment}
            alt="Logo do Governo de Pernambuco"
          />

          <ul className={styles.footerGovInfoSocialMediaLinks}>
            {socialMediaLinks.map(({ link, Icon }, index) => (
              <li className={styles.footerGovInfoSocialMediaLink} key={index}>
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Link para redes sociais: ${link}`}
                >
                  <Icon className={styles.footerGovInfoSocialMediaLinkIcon} />
                </a>
              </li>
            ))}
          </ul>
        </section>

        <hr />

        <section className={styles.footerGovInfoContactsContainer}>
          <ul className={styles.footerGovInfoContacts}>
            {contacts.map(({ Icon, text, link, target }, index) => (
              <li className={styles.footerGovInfoContactsItem} key={index}>
                <a href={link} target={target || ''}>
                  <Icon className={styles.footerGovInfoContactsItemIcon} />
                  <span>{text}</span>
                </a>
              </li>
            ))}
          </ul>

          {/* <section className={styles.footerGovInfoPartnersContainer}>
            <img
              src={LogoATI}
              alt="Logo agência estadual de tecnologia da informação"
            />
            <img
              src={LogoLigaDigital}
              alt="Logo liga digital, governo digital de Pernambuco"
            />
          </section> */}
        </section>
      </section>
    </>
  );
};
